import { Stack, Text } from "@mantine/core";
import { PushNotificationRecord } from "../models/PushNotificationRecord";
import { convertToLocalDateTime } from "../utilities/DateUtil";

interface PushNotificationDrawerProps {
  selectedRecord: PushNotificationRecord | null;
}

export const PushNotificationDrawer = ({
  selectedRecord
}: PushNotificationDrawerProps) => {
  return (
    <>
      {selectedRecord && (
        <Stack w={400}>
          <Text span fw={700}>Conditions:</Text>
          <Text span>{selectedRecord.userFilterConditions}</Text>
          <Text span fw={700}>Title:</Text>
          <Text span>{selectedRecord.title}</Text>
          <Text span fw={700}>Body:</Text>
          <Text span>{selectedRecord.body}</Text>
          <Text span fw={700}>Event Type:</Text>
          <Text span>{selectedRecord.eventType}</Text>
          <Text span fw={700}>Link:</Text>
          <Text span>{selectedRecord.link}</Text>
          <Text span fw={700}>Sender:</Text>
          <Text span>{selectedRecord.adminUserName}</Text>
          <Text span fw={700}>Device Attempts:</Text>
          <Text span>{selectedRecord.deviceAttempts}</Text>
          <Text span fw={700}>Device Successes:</Text>
          <Text span>{selectedRecord.deviceSuccesses}</Text>
          <Text span fw={700}>Send Time:</Text>
          <Text span>{convertToLocalDateTime(selectedRecord.sendTime)}</Text>
        </Stack>
      )}
    </>
  );
};
